<template>
<nav class="navbar is-heat-blue-1">
    <div class="navbar-brand">
        <router-link class="navbar-item" :to="isStaff? {name: 'staff_home'}:{name: 'home'}">
            <i class="fas fa-home fa-2x" title="Home"></i>
        </router-link>
        <a role="button" :class="[burgerOpen ? 'is-active': '']" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
           data-target="heatNavbar" @click="burgerOpen = !burgerOpen">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>
    </div>
    <div id="heatNavbar" class="navbar-menu" :class="[burgerOpen ? 'is-active': '']">
        <div v-if="isStaff" class="navbar-start">
            <div v-if="edars.length" class="navbar-item has-dropdown is-hoverable is-unselectable">
                <router-link class="navbar-link is-arrowless" :to="{name: 'edar_overview'}">
                    <img :src="EdarIcon" alt="EDAR Icon" title="EDAR Overview" height="100%">
                </router-link>
                <div class="navbar-dropdown dropdown-right">
                    <router-link v-for="(edar, index) in edars" v-bind:key="index + 1000"
                         :to="{name: 'edar_detail', params: {edarId: edar.id}}"
                         class="navbar-item is-flex"
                         style="justify-content: space-between; padding-right: 1rem; min-width: 14rem;"
                         exact-active-class="is-active"
                    >
                        <span :class="{
                                    'has-text-warning': edar.status === 'Faulted',
                                    'has-text-danger': edar.status === 'Offline',
                                    'has-underline': edar.status !== 'Online',
                                 }">
                            {{edar.name}}
                        </span>
                        <router-link tag="button" class="button title is-7"
                                     :to="{name: 'edar_staff_viewer', params: {edarId: edar.id}}"
                        >
                            LIVE
                        </router-link>
                    </router-link>
                </div>
            </div>
            <div v-if="deployments.length" class="navbar-item has-dropdown is-hoverable is-unselectable">
                <router-link class="navbar-link is-arrowless" :to="{name: 'deployment_overview'}">
                    <i class="fas fa-chart-line fa-2x" title="Deployment Overview"></i>
                </router-link>
                <div class="navbar-dropdown dropdown-right">
                    <router-link v-for="(deployment, index) in deployments" v-bind:key="index+1000000"
                             :to="{name: 'deployment_detail', params: {deploymentId: deployment.id}}"
                             class="navbar-item"
                             exact-active-class="is-active"
                    >
                        {{deployment.name}}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="navbar-end">
            <div class="navbar-item has-dropdown is-hoverable is-unselectable">
                <div class="navbar-link title is-4 is-hidden-mobile" style="margin-bottom: auto;">
                    &nbsp;{{ username }}&nbsp;
                </div>
                <div class="navbar-dropdown is-right">
                    <router-link v-if="isStaff && $store.state.debug" class="navbar-item" :to="{name: 'home'}">
                        Customer View
                    </router-link>
                    <hr v-if="isStaff && $store.state.debug" class="navbar-divider">
                    <a @click="showPasswordChange = true" class="navbar-item">
                        <i class="fas fa-key" title="Password Change"></i>&nbsp;&nbsp;Password Change
                    </a>
                    <a class="navbar-item" @click="logout()">
                        <i class="fas fa-sign-out-alt" title="Logout"></i>&nbsp;&nbsp;Logout
                    </a>
                </div>
            </div>
            <div class="navbar-item" @click="debugCounter += 1"></div>
        </div>
    </div>
    <password-change-modal :active.sync="showPasswordChange" :changeUrl="urls.password_change"></password-change-modal>
</nav>
</template>

<script>
    import {mapState} from "vuex";
    import urls from "../urls"
    import PasswordChangeModal from "heat-shared/src/components/PasswordChangeModal";
    import EdarIcon from "heat-shared/static/Edar Icon.svg"

    export default {
        name: "Navbar",
        components: {PasswordChangeModal},
        mixins: [urls],
        data: () => ({
            burgerOpen: false,
            showPasswordChange: false,
            debugCounter: 0,
        }),
        computed: {
            ...mapState('user', [
                'username',
                'isStaff'
            ]),
            ...mapState('edar', [
                'edars',
            ]),
            ...mapState('deployment', [
                'deployments',
            ]),
            EdarIcon: () => EdarIcon,
        },
        methods: {
            async logout() {
                await this.$store.dispatch('user/logout');
                this.$router.push({name: 'home'})
            },
        },
        watch: {
            //Enable debug mode if the counter goes over 10
            debugCounter(value) {
                if (value > 10 && !this.$store.state.debug) {
                    this.$store.commit('setDebug', true);
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    /*This fixes the arrow not changing color*/
    .has-text-white {
        &.navbar-link::after {
            border-color: white;
        }
    }

    //Add an oval white background to navbar-start and navbar-end
    //Also allows for a dropdown without the result looking terrible
    .nav-background-fix {
        $border-radius: 1.5rem;

        border-radius: $border-radius;
        > .navbar-item {
            border-radius: $border-radius; //Fixes the border when hovering on the items on the ends
        }

        .has-dropdown {
            .navbar-link {
                border-radius: $border-radius;  //Fixes the border when hovering on the items on the ends
            }

            .navbar-dropdown {
                border-radius: 6px; //Round all the edges of the dropdown
            }
        }
    }
</style>